import {MeasurementTypeConfiguration} from "@/core/services/MedicaPro/models";

export class MeasurementTypeConfigurationRow {
    public identifier: string;
    public configuration?: MeasurementTypeConfiguration;

    constructor(identifier: string) {
        this.identifier = identifier;
    }
}
